import Facade from '@/Facade'

export class WinningUtil {
    public static getBigWinLevel(amount: number, bet: number): number {
        const bigWinConfig = Facade.winningsConfig.BIG_WIN
        const minBigWinAmount = Number(Facade.winningsConfig.MIN_BIG_WIN_AMOUNT ?? 0)

        if (amount < minBigWinAmount || bet <= 0) {
            return null
        }

        const currentX = amount / bet

        for (let level = bigWinConfig.length - 1; level >= 0; level--) {
            const tier = bigWinConfig[level]
            const upperBound = Number(tier.to)
            const isLastTier = level === bigWinConfig.length - 1
            const isInUpperBound = isLastTier || Number.isNaN(upperBound) || currentX <= upperBound

            if (currentX >= Number(tier.from) && isInUpperBound) {
                return level
            }
        }

        return null
    }
}
